import { render, staticRenderFns } from "./AttributeChange.vue?vue&type=template&id=c7721ef4&scoped=true&"
import script from "./AttributeChange.vue?vue&type=script&lang=js&"
export * from "./AttributeChange.vue?vue&type=script&lang=js&"
import style0 from "./AttributeChange.vue?vue&type=style&index=0&id=c7721ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7721ef4",
  null
  
)

export default component.exports